module.exports = __webpack_public_path__ + "img/1871665975304.97c81a30.png";